import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import {Container,Row,Col,Button, Form, FormGroup, Label, Input, FormText} from 'reactstrap';

export default class Contact extends Component {
  render() {
    return (
      <div>
      <Menu />
      <Container id="body-contact">
        <Row className="judul-contact" align="center">
          <Col sm="12">
            <h1><b>ARE</b> YOU READY?</h1><br/>
            <div className="line-contact"/>
            <h4>let's talk about business</h4>
          </Col>
        </Row><br/>
        <Row>
          <Col sm="12">
            <Form>
              <FormGroup row>
                <Label for="name" sm={2}>Name</Label>
                <Col sm={10}>
                  <Input type="text" name="name" id="name" placeholder="Youre Name..." />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="email" sm={2}>Email</Label>
                <Col sm={10}>
                  <Input type="email" name="email" id="email" placeholder="example : contoh@gmail.com" />
                </Col>
              </FormGroup>   
              <FormGroup row>
                <Label for="subjek" sm={2}>Subjek</Label>
                <Col sm={10}>
                  <Input type="text" name="subjek" id="subjek" placeholder="Subjek" />
                </Col>
              </FormGroup>   
              <FormGroup row>
                <Label for="exampleText" sm={2}>Youre Message</Label>
                <Col sm={10}>
                  <Input type="textarea" name="text" id="exampleText" />
                </Col>
              </FormGroup><br/>
              <FormGroup check row><br/>
                <Col sm="12" align="center">
                  <Button type="submit" outline color="primary" size="lg">Send Message</Button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row><br/>
        <Row>
          <Col sm="12">

          </Col>
        </Row>
      </Container>
      <Footer/>      
      </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/contact.js